/**
 * @vuepress
 * ---
 * title: file
 * ---
 */
import Transformer from '@/transformers/transformer'

/**
 * @class reinvoicingTransformer
 * Reinvoicing payload transformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */
class reinvoicingTransformer extends Transformer {
  /**
   * Transform file to send
   *
   * @param file to send file
   *
   * @returns {Object} The transformed file
   */

  static send(file) {
    const formData = new FormData()
    formData.append('cfdi', file.id)
    formData.append('reinvoice_request_file', file.file)
    return formData
  }

}

export default reinvoicingTransformer


// WEBPACK FOOTER //
// ./src/transformers/taxReceipt/reinvoicing.js